<template>
  <AppDialog
    size="smedium"
    position="centered"
    append-to-body
    title="Delete shift"
    class="remove-schedule-dialog"
    :show="show"
    :subtitle="subtitle"
    @close="close"
  >
    <div
      v-if="showRemoveMultipleShiftsOption"
      class="d-flex flex-column"
    >
      <span
        v-for="option of deleteOptions"
        :key="option.id"
      >
        <div class="option mt-10">
          <input
            v-model="deleteOption"
            type="radio"
            name="delete-option"
            :value="option.id"
          />
          <span class="ml-10">{{ option.text }}</span>
        </div>
      </span>

      <div class="shift-warning mt-20">
        <div class="hi hi-warning orange hi-12"></div>
        <div>Shifts in the past cannot be recovered</div>
      </div>
    </div>

    <template #footer>
      <div>
        <template v-if="showRemoveMultipleShiftsOption">
          <div class="d-flex justify-content-end">
            <AppButton
              type="default"
              class="mr-5"
              @click.once="close"
            >
              Cancel
            </AppButton>
            <AppButton
              type="danger"
              @click.once="destroy"
            >
              Delete
            </AppButton>
          </div>
        </template>
        <template v-else>
          <AppButton
            type="danger"
            class="w-full"
            @click.once="destroy"
          >
            Delete
          </AppButton>
        </template>
      </div>
    </template>
  </AppDialog>
</template>

<script>
import { applyTemplate } from '~/utils/url_template';
import { ATTENDANCE_SCHEDULE_URL, ATTENDANCE_SHIFT_URL } from '~/app_constants';
import { mapInertiaProps } from '~/utils/inertia';

export default {
  name: 'RemoveAttendanceScheduleDialog',
  props: {
    show: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: 'Remove Shift',
    },
    event: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showAttendanceShiftDialog: false,
      deleteOption: 1,
    };
  },
  computed: {
    ...mapInertiaProps({
      filteredUserIds({ calendar_resources: calendarResource }) {
        return (calendarResource?.users || []).map((user) => user.id);
      },
    }),
    shift() {
      return this.event.shiftAttributes;
    },
    showRemoveMultipleShiftsOption() {
      return this.shift.attendanceScheduleId && this.shift.isRecurring;
    },
    isFirstOccurrence() {
      return moment(this.shiftFirstOccurrence).isSame(this.eventStartDate, 'day');
    },
    shiftFirstOccurrence() {
      return moment.utc(this.shift.first_occurrence).format('YYYY-MM-DD');
    },
    eventStartDate() {
      return moment.utc(this.event.startStr).format('YYYY-MM-DD');
    },
    subtitle() {
      return this.shift.formattedStartDate;
    },
    deleteOptions() {
      return [
        {
          id: 1,
          // If the shift is not recurring then delete the whole schedule
          action: this.shift.isRecurring ? 'exclude_date' : '',
          text: 'Only this shift',
        },
        {
          id: 2,
          // If the it's the first occurrence of the shift then delete the whole schedule
          action: this.isFirstOccurrence ? '' : 'remove_shifts',
          text: 'Selected shift and all future shifts',
        },
        {
          id: 3,
          action: '',
          text: 'All occurences',
        },
      ];
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    destroy() {
      let option;

      if (this.shift.attendanceScheduleId) {
        option = {
          method: 'deleteSchedule',
          params: this.deleteOptions.find((option) => option.id === this.deleteOption).action,
        };
      } else {
        option = { method: 'deleteShift', params: '' };
      }

      return this[option.method](option.params);
    },
    deleteShift() {
      const url = applyTemplate(`${ATTENDANCE_SHIFT_URL}`, {
        organizationId: this.shift.organizationId,
        attendanceShiftId: this.shift.id,
      });

      this.delete(url);
    },
    deleteSchedule(destroySuffix = '') {
      const url = applyTemplate(`${ATTENDANCE_SCHEDULE_URL}/${destroySuffix}`, {
        attendanceScheduleId: this.shift.attendanceScheduleId,
      });
      const stopDate = moment(this.eventStartDate).subtract(1, 'day').format('YYYY-MM-DD');
      const data = {
        date: this.shift.date,
        organization_id: this.shift.organizationId,
        attendance_schedule_id: this.shift.attendanceScheduleId,
        ...(this.shift.isRecurring && { end_date: stopDate }),
      };

      this.delete(url, data);
    },
    async delete(url, data = {}) {
      data.filtered_user_ids = this.filteredUserIds;

      await this.$inertia.delete(url, {
        data,
        onSuccess: () => {
          this.close();
        },
      });
    },
  },
};
</script>
